// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1HS_Y","buttons":"PendingPaymentAlert_buttons__reeaO"};